import React from 'react';

const stampStyle = {
  width: '110px',
  height: '110px',
  borderRadius: '50%',
  border: '6px double #c53030',
  color: '#c53030',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform: 'rotate(-12deg)',
  opacity: 0.85,
  fontFamily: 'Georgia, serif',
  fontWeight: 'bold',
  fontSize: '26px',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  margin: '20px 0'
};

const Certificate = ({ name, email, score, total, passMark, date, version }) => {
  return (
    <div style={{ border: '10px solid #1a365d', padding: '6px', margin: '20px 0 30px 0' }}>
      <div style={{ border: '2px solid #b7791f', padding: '30px 20px', backgroundColor: '#fffdf7', textAlign: 'center' }}>
        <img
          src="/icebergers-logo.gif"
          alt="Brighton Icebergers logo"
          style={{ height: '80px', marginBottom: '4px' }}
        />
        <p style={{ margin: 0, letterSpacing: '2px', textTransform: 'uppercase', color: '#555', fontSize: '13px' }}>
          Royal Brighton Yacht Club
        </p>

        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '32px', margin: '10px 0 0 0', color: '#1a365d' }}>
          Certificate of Completion
        </h1>

        <p style={{ margin: '25px 0 0 0', fontSize: '16px' }}>This certifies that</p>
        <p style={{ fontFamily: 'Georgia, serif', fontSize: '30px', fontWeight: 'bold', margin: '8px 0', color: '#1a365d' }}>
          {name}
        </p>
        <p style={{ margin: '0 0 4px 0', color: '#555' }}>{email}</p>
        <p style={{ margin: 0, fontSize: '16px' }}>
          has completed the Brighton Icebergers Safety Induction Program
        </p>

        <p role="status" style={{ fontSize: '18px', margin: '20px 0 0 0' }}>
          Scored <strong>{score} out of {total}</strong> &mdash; pass mark {passMark}. Passed.
        </p>

        <div style={{ textAlign: 'center' }}>
          <div style={stampStyle} aria-hidden="true">Pass</div>
        </div>

        <p style={{ margin: 0, color: '#555', fontSize: '14px' }}>
          Date: {date} &middot; Course: {version}
        </p>
        <p style={{ margin: '25px 0 0 0', color: '#555', fontSize: '13px' }}>
          Brighton Icebergers Safety Induction Program &mdash; prepared by the RBYC Aquatic Subcommittee
        </p>
      </div>
    </div>
  );
};

export default Certificate;
